import * as React from 'react';
import { faUnderline } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TiptapButton } from '../TiptapButton';
import { useEditorContext } from '../../editor_context';
import { useLocalization } from '~/framework';

export const UnderlineButton = () => {
   const { _js } = useLocalization();
   const { editor } = useEditorContext();

   return (
      <TiptapButton
         onClick={() => editor.chain().focus().toggleUnderline().run()}
         isDisabled={!editor.can().toggleUnderline()}
         isActive={editor.isActive('underline')}
         icon={<FontAwesomeIcon icon={faUnderline} />}
         title={_js('Underline')}
         shortcut={'u'}
      />
   );
};
